import { render } from "./ParquedasFlores.vue?vue&type=template&id=335df1b9"
import script from "./ParquedasFlores.vue?vue&type=script&lang=js"
export * from "./ParquedasFlores.vue?vue&type=script&lang=js"

import "./ParquedasFlores.vue?vue&type=style&index=0&id=335df1b9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__